/*
 * WARNING: This file was automatically generated.
 * Changes must be made to the package.templateroot, or they will be lost!
 */
export enum IControlType {
  Incline = 'incline',
  Mps = 'mps',
  Resistance = 'resistance',
  Gear = 'gear',
  Rpm = 'rpm',
  Watts = 'watts',
  Calories = 'calories',
  Zone = 'zone',
  Spm = 'spm',
  RelativeResistance = 'relativeResistance',
}
